var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 31H21.3335C23.1744 31 24.6668 29.5076 24.6668 27.6667V11.6904C24.6668 11.2483 24.4912 10.8244 24.1787 10.5118L15.155 1.48816C14.8424 1.17559 14.4185 1 13.9765 1H4.66683C2.82588 1 1.3335 2.49238 1.3335 4.33333V22.6667M1.3335 31L9.46463 22.8689M9.46463 22.8689C10.3695 23.7737 11.6195 24.3333 13.0002 24.3333C15.7616 24.3333 18.0002 22.0948 18.0002 19.3333C18.0002 16.5719 15.7616 14.3333 13.0002 14.3333C10.2387 14.3333 8.00016 16.5719 8.00016 19.3333C8.00016 20.714 8.55981 21.964 9.46463 22.8689Z",
    stroke: "#25A249",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.2d436adef5bbd4b9a319e76ebe452d84.svg";
export { ForwardRef as ReactComponent };